import React from "react";
import { InputBase, InputAdornment, Button, Chip } from "@material-ui/core";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import SelectBranch from "../components/selectBranchWithMap";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme = {}) => {
  if (!theme) return {};
  return {
    groupBtn: {
      display: "flex",
      alignItems: "center",
    },
    root: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: theme.spacing(3),
      height: "2.3rem",
    },
    search: {
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      marginRight: theme.spacing(2),
      marginLeft: 0,
      height: "2.6rem",
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      display: "flex",
      height: "2.3rem",
    },
    searchIconContainer: {
      width: theme.spacing(6),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    searchIcon: {
      fill: "#546e7a",
    },
    containerSearch: {
      display: "flex",
      alignItems: "center",
    },
    containerBtnSearch: {
      height: "2.3rem",
      width: "100%",
    },
    btnSearch: {
      height: "100%",
      backgroundColor: "#fff",
      fontSize: "0.9375rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.8rem",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.6rem",
      },
      minWidth: "max-content",
    },
    inputRoot: {
      color: "inherit",
      width: "100%",
      borderRadius: "4px",
      boxShadow: theme.shadows[2],
      minHeight: "unset",
    },
    inputInput: {
      fontSize: "1rem",
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(6),
      transition: theme.transitions.create("width"),
      width: 200,
      "&::placeholder ": {
        textOverflow: "ellipsis",
      },
      "&:focus": {
        width: 300,
      },
      [theme.breakpoints.down("sm")]: {
        width: 100,
        "&:focus": {
          width: 200,
        },
      },
    },
    buttonFilter: {
      marginLeft: "1rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.8rem",
      },
      height: "2.3rem",
    },
    iconFilter: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    adornmentRoot: {
      marginRight: theme.spacing(1),
      "& svg": {
        fontSize: "1rem",
        cursor: "pointer",
      },
    },
    chipFilter: {
      marginRight: theme.spacing(1)
    }
  };
});

function CustomizedInputBase(props) {
  const classes = useStyles();
  const {
    t,
    placeholder = "Searching",
    value,
    onChange,
    getList,
    showFilter = false,
    openFilter,
    listFilter,
    showFilterBranch = false,
    handleChangeBranch,
    customBtn,
    filterCustom,
    deleteSearchAndGetList,
    ...other
  } = props;
  const handleSearch = (event) => {
    event.preventDefault();
    getList({ search: value, page: 0 }, false);
  };
  function renderChipFilter(filters) {
    const { t } = props;
    let listChip = []
    for (const key in filters) {
      if (filters[key]) {
        listChip.push(
          <Chip
            key={`list-filter-${key}`}
            icon={<FilterListIcon />}
            label={`${t(key)}: ${t(filters[key])}`}
            variant="outlined"
            color="primary"
            className={classes.chipFilter}
          />
        )
      }
    }
    return listChip;
  }
  return (
    <div>
      <div className={classes.root}>
        <form onSubmit={handleSearch} className={classes.containerSearch}>
          <div className={classes.search}>
            <div className={classes.searchIconContainer}>
              <SearchIcon className={classes.searchIcon} />
            </div>
            <InputBase
              {...other}
              value={value}
              onChange={onChange}
              placeholder={t(placeholder)}
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              endAdornment={
                <InputAdornment
                  onClick={() => deleteSearchAndGetList()}
                  classes={{
                    root: classes.adornmentRoot,
                  }}
                  position="end"
                >
                  <CloseIcon />
                </InputAdornment>
              }
            />
          </div>
          <div className={classes.containerBtnSearch}>
            <Button
              variant="contained"
              className={classes.btnSearch}
              onClick={() => getList({ search: value }, false)}
            >
              {t("search")}
            </Button>
          </div>
        </form>
        <div className={classes.groupBtn}>
          {Boolean(customBtn) ? (
            customBtn()
          ) : (
            <>
              {filterCustom && filterCustom()}
              {showFilterBranch && handleChangeBranch && (
                <SelectBranch handleChange={handleChangeBranch} />
              )}
              {showFilter && openFilter && (
                <Button
                  onClick={openFilter}
                  className={classes.buttonFilter}
                  variant="outlined"
                  color="primary"
                >
                  <FilterListIcon
                    color="primary"
                    className={classes.iconFilter}
                  />
                  {t("show_filter")}
                </Button>
              )}
            </>
          )}
        </div>
      </div>
      {renderChipFilter(listFilter)}
    </div>
  );
}

CustomizedInputBase.propTypes = {
  getList: PropTypes.func.isRequired,
};

export default translate("translations")(CustomizedInputBase);
